import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect, useMemo } from 'react';
import {
  selectAuthLoading,
  selectAuthenticated,
  selectUserType,
  selectChatWidgetQueryParams,
} from 'modules/Authentication/slice/selectors';

import { AppDefaults, UserTypes } from 'config/global-enums';
import CustomFooter from '../../Decorators/CustomFooter';
import { Layout } from 'antd';
import { Loader } from 'modules/common/Loaders/Loader';
// import PublicNavbar from '../../Decorators/PublicNavbar';
import { StyleConstants } from 'styles/StyleConstants';
import { selectInstallHeaderVisible } from 'modules/common/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import NewPublicNavBar from 'modules/common/Decorators/NewPublicNavBar';
import { useThemeSlice } from 'styles/theme/slice';
import { CDN_DOMAIN, DOMAIN } from 'config/api-variables';
import { removeHttpHttpsWww } from 'utils/tools/data-transformers';
import { defaultAuthHome } from 'modules/common/defaultAuthHome';
import { useAuthenticationFormSlice } from 'modules/Authentication/slice';

export default function PublicRoutesLoader({ disableFullScroll, ...props }) {
  const location = useLocation();

  const isAuthLoading = useSelector(selectAuthLoading);
  const isAuthenticated = useSelector(selectAuthenticated);
  const showInstallHeader = useSelector(selectInstallHeaderVisible);
  const userType = useSelector(selectUserType);
  const chatWidgetQueryParams = useSelector(selectChatWidgetQueryParams);

  const dispatch = useDispatch();
  const { actions } = useAuthenticationFormSlice();
  const { actions: themeActions } = useThemeSlice();

  const subLayoutHeight = useMemo(() => {
    if (!props.hidePublicNavbar && showInstallHeader) {
      return `calc((100vh - ${StyleConstants.NAV_BAR_HEIGHT}) - ${StyleConstants.INSTALL_HEADER_HEIGHT})`;
    } else if (!props.hidePublicNavbar || showInstallHeader) {
      return `calc(100vh - ${
        !props.hidePublicNavbar
          ? StyleConstants.NAV_BAR_HEIGHT
          : StyleConstants.INSTALL_HEADER_HEIGHT
      })`;
    } else {
      return '100vh';
    }
  }, [props.hidePublicNavbar, showInstallHeader]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const changeTheme = () => {
      dispatch(themeActions.changeTheme('default'));
    };

    if (
      removeHttpHttpsWww(window.location.hostname) ===
      removeHttpHttpsWww(DOMAIN)
    ) {
      changeTheme();
    }

    const script = document.createElement('script');
    if (!chatWidgetQueryParams) {
      const queryString = Math.random().toString(36).substring(7);
      dispatch(actions.setChatWidgetQueryParams(queryString));
      console.log(queryString, 'queryString nikkesh');
      script.src =
        CDN_DOMAIN + `/public/build/clean_ai_bot.js?q=${queryString}`;
    }

    script.defer = true;
    document.head.appendChild(script);

    return () => {
      // Clean up script when component unmounts
      document.head.removeChild(script);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return props.path !== '/' && props.allowedAfterLogin && isAuthLoading ? (
    <Loader />
  ) : !props.allowedAfterLogin && isAuthenticated ? (
    <Navigate
      replace
      // to={location?.state?.prevRoute || AppDefaults.AUTH_HOME}
      to={defaultAuthHome[userType] || defaultAuthHome[UserTypes.EMPLOYEE]}
    />
  ) : (
    <Layout
      style={{
        height:
          disableFullScroll &&
          `calc(100vh - ${
            showInstallHeader ? StyleConstants.INSTALL_HEADER_HEIGHT : '0px'
          } )`,
      }}
    >
      {!props.hidePublicNavbar && <NewPublicNavBar />}
      {/* {!props.hidePublicNavbar && <PublicNavbar />} */}
      <Layout
        style={{
          minHeight: subLayoutHeight,
          overflowX: 'hidden',
        }}
      >
        {props.children}
        {!props.hideChatWidget && (
          <>
            {process.env.REACT_APP_ENV === 'test' ? (
              <></>
            ) : (
              <cleandesk-chat-widget
                app_id="jRYeur8FnzK-PJ35xpg1MUdu_qa0Qr49xpbhcCO6ZQbn3A_46ecDBxImIiMWAbHxHH-L2SVZBickVBLKwJzZ_w"
                app_secret="nWkx064XSmDRsrRuhYDm0vXuQcxDz-Qam5XW6ae6UysF8HKWutjhMb451I7q-_N4Ew7l30u6yDz-S_QLvo6b3OzfEqvwGESuo2crXzW6v8bt6ZxJzB0cIRsBkmJ1Fw7OoP3ENlfQToW8VP18DnPX9exZpFmnO9uv3hHz-O_nda8"
                access_by_id=""
                access_by_type="customer"
              ></cleandesk-chat-widget>
            )}
          </>
        )}
      </Layout>
      {!props.hideCustomFooter && <CustomFooter />}
    </Layout>
  );
}
